<script setup lang="ts">
import {defineProps} from 'vue';
import {useRouter} from 'vue-router';
import SuccessOrErrorComponent from "@/components/common/SuccessOrErrorComponent/SuccessOrErrorComponent.vue";

const router = useRouter();

const props = defineProps<{
  message?: string;
  id?: string;
}>();

const goToHome = () => {
  router.push({name: 'home'});
};

const goToListing = () => {
  router.push({name: 'listing', params: {id: props.id}});
}

const message = (props.id) ? "¡EL ANUNCIO HA SIDO CREADO CORRECTAMENTE!" : props.message;

</script>

<template>

  <div class="section-container">
    <div class="section">
      <success-or-error-component :status="(props.id != null) ? 'ok'  : 'error'"
                                  :text="message"
                                  primaryButtonText="VOLVER AL INICIO"
                                  :secondaryButtonText="(props.id != null) ? 'VER EL ANUNCIO' : ''"
                                  @primary-click="goToHome"
                                  @secondary-click="goToListing">

      </success-or-error-component>
    </div>
  </div>

</template>

<style scoped lang="scss">
@import "CreateListingSuccessComponent";
</style>